import { useLanguage } from "~/apps/corporate/contexts/language.context";
import { LanguageCode } from "~/apps/shared/constants/enums";

const transcriptions = {
  [LanguageCode.EN_US]: {
    empty: "No cards registered.",
    link: "Add payment method",
    menu: {
      edit: "Edit",
      remove: "Remove",
    },
    title: "Payment methods",
    tooltipWarning:
      "The travel manager did not allow the registration of individual cards for purchases",
    expired: "Card expired",
  },
  [LanguageCode.PT_BR]: {
    empty: "Nenhum cartão cadastrado.",
    link: "Adicionar meio de pagamento",
    menu: {
      edit: "Editar",
      remove: "Remover",
    },
    title: "Meios de pagamento",
    tooltipWarning:
      "O gestor de viagens não permitiu o cadastro de cartões individuais para compras",
    expired: "Cartão expirado",
  },
} as const;

export const useUserProfileDrawerCardsSectionTranscription = () => {
  const { languageCode } = useLanguage();

  const transcription =
    transcriptions[languageCode as keyof typeof transcriptions];

  return { transcription };
};
